import { render, staticRenderFns } from "./smartControl_page.vue?vue&type=template&id=384d305a&scoped=true"
import script from "./smartControl_page.vue?vue&type=script&lang=js"
export * from "./smartControl_page.vue?vue&type=script&lang=js"
import style0 from "./smartControl_page.vue?vue&type=style&index=0&id=384d305a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "384d305a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\2026\\Halov2-Fishery-Upgrade\\halov-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('384d305a')) {
      api.createRecord('384d305a', component.options)
    } else {
      api.reload('384d305a', component.options)
    }
    module.hot.accept("./smartControl_page.vue?vue&type=template&id=384d305a&scoped=true", function () {
      api.rerender('384d305a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/iot/smartControl/smartControl_page.vue"
export default component.exports